import { render, staticRenderFns } from "./svgIcon.vue?vue&type=template&id=7b985f16"
import script from "./svgIcon.vue?vue&type=script&lang=js"
export * from "./svgIcon.vue?vue&type=script&lang=js"
import style0 from "./svgIcon.vue?vue&type=style&index=0&id=7b985f16&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
